import { render, staticRenderFns } from "./AstraCardAgreeButtons.vue?vue&type=template&id=8d1f6600"
import script from "./AstraCardAgreeButtons.vue?vue&type=script&lang=js"
export * from "./AstraCardAgreeButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports